import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/(studio)/welcome")({
  beforeLoad: () => {
    throw redirect({ to: "/" });
  },
});
